/**
 * Identité admin utilisée côté client.
 *
 * Ces valeurs étaient dupliquées dans Chart/Charts.tsx et
 * Game/History/Histories.tsx. Elles vivent ici pour qu'un changement de pseudo
 * n'ait qu'un seul endroit à corriger, et pour qu'importer la constante ne
 * tire pas au passage tout le module de graphiques.
 *
 * Pour un contrôle d'accès réel, préférer le flag serveur `me.isAdmin`
 * (exposé par GET_ME) : il ne dépend pas du pseudo.
 */
export const ADMIN_USERNAME = "Manest";

/** Compte admin exclu des statistiques de dépenses. */
export const ADMIN_ID = "fde46572-9dbe-4354-ad56-579860d7c0a2";
